<div class="tile" (click)="openMainDeviceQuickView()">
  <!-- 1 device standalone  -->
  <ng-container
    *ngIf="installation.devices.length === 1 && installation.isStandalone; else showRegularImages"
  >
    <img class="main-device-image" [src]="standaloneImagePath" />
  </ng-container>
  <ng-template #showRegularImages>
    <ng-container *ngIf="imagePath; else hideImage">
      <img class="main-device-image" [src]="imagePath" />
    </ng-container>
    <ng-template #hideImage>
      <mat-icon class="hide-image">hide_image</mat-icon>
    </ng-template>
  </ng-template>
  <div class="data">
    <div class="header">
      <div class="header__text">
        <div class="flex items-center">
          <h4 *ngIf="installationHeaderLabel">
            {{ installationHeaderLabel }}
          </h4>
          <img *ngIf="brandLogo" class="mt-[-2px]" src="{{ brandLogo }}" />
        </div>
        <ng-container *ngrxLet="upgradePackageData$ as upgradePackageData">
          <app-pill
            *ngIf="upgradePackageData?.visible"
            [type]="pillType.bright"
            (click)="navigateToBooking($event, upgradePackageData.platform)"
            class="upgrade-pill"
          >
            <span class="upgrade-badge">
              <span>
                {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.UPGRADE_TO_PRO' | translate }}
              </span>
              <mat-icon class="shortcut-icon" svgIcon="shortcut"></mat-icon>
            </span>
          </app-pill>
        </ng-container>
        <app-booking-package-badge
          *ngIf="isMainDeviceBadgeVisible"
          [packageType]="installation.device | highestSubscriptionPlan"
          [size]="'inline'"
        ></app-booking-package-badge>
      </div>
      <mat-icon class="more-icon" [matMenuTriggerFor]="menu" (click)="openManageMenu($event)">
        more_vert
      </mat-icon>
    </div>
    <div class="additional">
      <p>{{ installation.device?.vin }}</p>
      <p>{{ installation.owner?.firstName }} {{ installation.owner?.lastName }}</p>
      <p>{{ installation.address.street }} {{ installation.address.houseNumber }}</p>
      <p>{{ installation.address.zip }} {{ installation.address.city }}</p>
    </div>
    <!-- Single device badges -->
    <div class="badges">
      <app-installation-tile-badges
        [installation]="installation"
        [showDuplicationIcon]="isColumnSelfDefined"
      ></app-installation-tile-badges>
    </div>

    <div class="multiple-devices" *ngIf="!isSingleDevice">
      <ng-container *ngFor="let device of installation.devices; index as index">
        <ng-container>
          <div
            *ngIf="isShowingMoreDevices ? true : index < defaultQuantityOfVisibleDevices"
            class="device-tile"
            (click)="openDeviceQuickView($event, index)"
          >
            <div
              *ngIf="device.pictogramImage || device.materialImage; else hideIcon"
              class="device-tile__image"
            >
              <img [src]="device.pictogramImage || device.materialImage" />
            </div>
            <ng-template #hideIcon>
              <mat-icon class="device-tile__icon">hide_image</mat-icon>
            </ng-template>
            <div class="device-tile__text">
              <div class="device-tile__text__header flex">
                <span>
                  {{ device.marketingName }}
                </span>
                <img
                  *ngIf="device.brandLogo"
                  class="mt-[-4px] brand-logo"
                  src="{{ device.brandLogo }}"
                />
              </div>
              <div>{{ device.vin }}</div>
              <div class="device-tile__text__badges">
                <app-installation-tile-device-badges [device]="device">
                  <ng-container paidPackage *ngIf="installation.isMultiGateway">
                    <ng-container
                      *ngIf="device | highestSubscriptionPlan as highestSubscriptionPlan"
                    >
                      <app-booking-package-badge
                        *ngIf="
                          highestSubscriptionPlan === subscriptionPlan.Pro ||
                          highestSubscriptionPlan === subscriptionPlan.Plus
                        "
                        [packageType]="highestSubscriptionPlan"
                        [size]="'inline'"
                      ></app-booking-package-badge>
                    </ng-container>
                  </ng-container>
                </app-installation-tile-device-badges>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="installation.devices.length > defaultQuantityOfVisibleDevices">
        <button
          *ngIf="!isShowingMoreDevices"
          mat-stroked-button
          color="primary"
          gtm="onSelect"
          gtmAction="Show more devices"
          gtmCategory="kanbanBoard"
          (click)="manageDevicesVisibility($event, true)"
        >
          <span> {{ 'GENERAL.BUTTON.SHOW_MORE' | translate }} </span>
          <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
        </button>
        <button
          *ngIf="isShowingMoreDevices"
          mat-stroked-button
          color="primary"
          gtm="onSelect"
          gtmAction="Show less devices"
          gtmCategory="kanbanBoard"
          (click)="manageDevicesVisibility($event, false)"
        >
          <span> {{ 'GENERAL.BUTTON.SHOW_LESS' | translate }} </span>
          <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Three dot menu  -->
<mat-menu #menu="matMenu" (closed)="onMenuClosed()" class="kanban-tile-dots-menu">
  <button *ngIf="!isColumnSelfDefined" mat-menu-item [matMenuTriggerFor]="columnsList">
    <span> {{ '+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.COPY' | translate }} </span>
  </button>
  <ng-container *ngIf="isColumnSelfDefined">
    <button mat-menu-item [matMenuTriggerFor]="columnsList">
      <span> {{ '+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.MOVE' | translate }} </span>
    </button>
    <button mat-menu-item (click)="removeInstallationDuplication()">
      <span>{{
        '+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.REMOVE_DUPLICATION' | translate
      }}</span>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #columnsList="matMenu" [class]="'kanban-columns-menu'">
  <div class="column-list">
    <ng-container *ngIf="selfMadeColumnsWithoutInstallations$ | async as columns">
      <div *ngFor="let column of columns" (click)="handleColumnAction(column)" class="list-entry">
        <mat-icon class="arrow-icon">arrow_right</mat-icon>
        <span> {{ column.name }}</span>
      </div>
    </ng-container>
    <div
      *ngrxLet="kanbanBoardStore.selectIsLimitOfSelfDefinedColumnsHit$ as columnLimitHit"
      class="flex flex-col"
    >
      <div
        class="list-entry list-entry--last"
        (click)="createNewColumn()"
        [class.disabled]="columnLimitHit"
      >
        <mat-icon class="add-icon">add</mat-icon>
        <span>
          {{ '+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.CREATE_NEW_COLUMN' | translate }}
        </span>
      </div>
      <div *ngIf="columnLimitHit" class="column-limit-info">
        {{
          '+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.DISABLE_CREATE_NEW_COLUMN'
            | translate: { limit: limitOfSelfDefinedColumns }
        }}
      </div>
    </div>
  </div>
</mat-menu>
